module.exports = __webpack_public_path__ + "93732980c0ee05bb159016bfcc9ad0bc.svg";